import * as React from "react"
import { PropsWithChildren } from "react"

import { Separator, SeparatorContainer, SeparatorHeader, SeparatorText } from "./styles"

export interface SeparatorConfig {
  title: string;
  subtitle: string;

}

export default function SeparatorComponent(props: PropsWithChildren<SeparatorConfig>) {
  return (
    <Separator>
      <SeparatorContainer>
        <SeparatorHeader>
          <h1>{props.title}</h1>
          <h2>{props.subtitle}</h2>
        </SeparatorHeader>
        <SeparatorText>{props.children}</SeparatorText>
      </SeparatorContainer>
    </Separator>
  )
}
